import './OverviewTile.scss'
import Link from './elements/link'
import dynamic from 'next/dynamic'
import { RichText } from 'prismic-reactjs'
const Image = dynamic(() => import('./elements/image'), { ssr: false, loading: () => null })

// TODO: if article_icon === "true", then image = icon
/*
shading: tile.shading,
textColor: tile.color
*/

export default function OverviewTile({ contents, type }) {
  return (
    <div className={`overview-tile ${type}`}>
      {contents.map((content, i) => {
        // TODO: mix in mobile image size
        let bgImage
        if (content.data.teaser_image) {
          bgImage = content.data.teaser_image
        } else if (content.data.title_image) {
          bgImage = content.data.title_image
        }
        // differentiate between referenced link or manual link
        let linkProps = {}
        if (content.data.link) {
          linkProps = Object.assign({}, content.data.link, { type: content.data.link.link_type })
        } else {
          linkProps = {
            route: `/${content.uid}`,
            type: 'internal'
          }
        }
        // if icon was selected, we use the image as icon, only if it wasnt referenced
        let showIcon = false
        let iconPath = null
        if (content.icon && content.data.icon_white) {
          iconPath = content.data.icon_white.url
          showIcon = !!content.icon // it used to be not in data back then
        } else if (content.data.icon === 'icon') {
          iconPath = content.data.teaser_image.url
          showIcon = content.data.icon === 'icon'
        }
        const inner = (
          <Image className="image" forceProperty={'desktop'} image={!showIcon && bgImage}>
            <div className="inner">
              {showIcon && iconPath && <img src={iconPath} className="icon-img" />}
              {content.data.title && <h2>{RichText.render(content.data.title)}</h2>}
              {content.data.text && <div className="text">{RichText.render(content.data.text)}</div>}
              {content.data.teaser_cta_label && <button>{content.data.teaser_cta_label}</button>}
              {content.data.subline && <div className="overview-subline">{content.data.subline}</div>}
            </div>
          </Image>
        )
        if (content.data.link.link_type === 'Any') {
          return <div className="overview-piece icon">{inner}</div>
        }
        return (
          <Link key={`content-${content.id}-${i}`} {...linkProps}>
            <a
              target={linkProps.target ? linkProps.target : ''}
              className={`overview-piece ${showIcon ? 'icon' : 'image'} ${
                content.data.shading === 'false' ? 'no-curtain' : 'curtain'
              } text-${content.data.textColor}`}
            >
              {inner}
            </a>
          </Link>
        )
      })}
    </div>
  )
}
